import React, { useState, useEffect, useRef } from 'react';
import api from '../api/client';

const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 14, marginBottom: 12, boxSizing: 'border-box', outline: 'none', display: 'block' };
const btnPrimary = { padding: '8px 16px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 500, fontSize: 13, cursor: 'pointer' };
const btnGhost = { padding: '7px 12px', background: 'none', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#555' };
const btnRed = { padding: '7px 12px', background: 'none', border: '1px solid #c0392b', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#c0392b' };

export default function CheckContacts() {
  const [accounts, setAccounts] = useState([]);
  const [accountIds, setAccountIds] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [delay, setDelay] = useState(1);
  const [error, setError] = useState('');
  const [taskId, setTaskId] = useState(null);
  const [task, setTask] = useState(null);
  const [tasks, setTasks] = useState([]);
  const logsRef = useRef();
  const pollRef = useRef();

  useEffect(() => {
    api.get('/accounts').then(r => {
      const active = r.data.filter(a => a.is_active);
      setAccounts(active);
      if (active.length) setAccountIds([active[0].id]);
    });
    loadTasks();
  }, []);

  useEffect(() => {
    if (logsRef.current) logsRef.current.scrollTop = logsRef.current.scrollHeight;
  }, [task?.logs]);

  useEffect(() => {
    if (taskId) {
      pollRef.current = setInterval(async () => {
        const { data } = await api.get(`/campaigns/check-tasks/${taskId}`);
        setTask(data);
        if (data.status === 'done' || data.status === 'stopped') {
          clearInterval(pollRef.current);
          setLoading(false);
          loadTasks();
        }
      }, 1500);
    }
    return () => clearInterval(pollRef.current);
  }, [taskId]);

  const loadTasks = async () => {
    const { data } = await api.get('/campaigns/check-tasks');
    setTasks(data);
  };

  const toggleAccount = (id) => {
    setAccountIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const start = async () => {
    if (!input.trim()) { setError('Введите номера'); return; }
    if (!accountIds.length) { setError('Выберите хотя бы один аккаунт'); return; }
    setLoading(true); setError(''); setTask(null);
    try {
      const { data } = await api.post('/campaigns/check-tasks', {
        targets_text: input,
        account_ids: accountIds,
        delay: parseFloat(delay),
      });
      setTaskId(data.task_id);
    } catch (e) {
      setError(e.response?.data?.detail || 'Ошибка');
      setLoading(false);
    }
  };

  const stop = async () => {
    if (!taskId) return;
    await api.post(`/campaigns/check-tasks/${taskId}/stop`);
    clearInterval(pollRef.current);
    setLoading(false);
  };

  const openTask = async (id) => {
    const { data } = await api.get(`/campaigns/check-tasks/${id}`);
    setTask(data);
    setTaskId(id);
  };

  const pct = task ? Math.round(task.checked / task.total * 100) : 0;
  const total = input.trim().split('\n').filter(l => l.trim()).length;

  return (
    <div style={{ padding: 32, maxWidth: 1000 }}>
      <h1 style={{ fontSize: 20, fontWeight: 600, margin: '0 0 6px' }}>🔍 Проверка базы</h1>
      <p style={{ fontSize: 13, color: '#888', margin: '0 0 24px' }}>
        Фоновая проверка — можно закрыть страницу и вернуться позже
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        {/* Левая колонка */}
        <div>
          <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 8 }}>Аккаунты для проверки</label>
          <div style={{ display: 'grid', gap: 6, marginBottom: 14, maxHeight: 180, overflow: 'auto' }}>
            {accounts.map(a => (
              <label key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', border: `1px solid ${accountIds.includes(a.id) ? '#534AB7' : '#e8e8e6'}`, borderRadius: 8, cursor: 'pointer', fontSize: 13, background: accountIds.includes(a.id) ? '#f0effe' : '#fff' }}>
                <input type="checkbox" checked={accountIds.includes(a.id)} onChange={() => toggleAccount(a.id)} />
                <span>{a.first_name || a.name}</span>
                <span style={{ fontSize: 11, color: '#aaa', marginLeft: 'auto' }}>{a.phone}</span>
              </label>
            ))}
          </div>

          <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>Номера телефонов или @username</label>
          <textarea
            value={input}
            onChange={e => setInput(e.target.value)}
            rows={12}
            placeholder={"+79001234567\n+79001234568\n@username"}
            style={{ ...inp, fontFamily: 'monospace', fontSize: 12, resize: 'vertical', marginBottom: 8 }}
            disabled={loading}
          />
          <div style={{ fontSize: 12, color: '#888', marginBottom: 12 }}>{total} номеров</div>
          {error && <div style={{ color: '#c0392b', fontSize: 13, marginBottom: 12 }}>{error}</div>}
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>Пауза между номерами (сек)</label>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              {[0.5, 1, 2, 3, 5].map(d => (
                <button key={d} onClick={() => setDelay(d)} style={{ padding: '5px 12px', borderRadius: 8, fontSize: 12, cursor: 'pointer', border: `1px solid ${delay === d ? '#534AB7' : '#e8e8e6'}`, background: delay === d ? '#f0effe' : '#fff', color: delay === d ? '#534AB7' : '#555', fontWeight: delay === d ? 600 : 400 }}>
                  {d}с
                </button>
              ))}
              <span style={{ fontSize: 11, color: '#aaa' }}>~{Math.round(374 * delay / 4 / 60)} мин для 374 номеров / 4 акк</span>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={start} disabled={loading} style={btnPrimary}>
              {loading ? '⏳ Проверяем...' : '🔍 Запустить проверку'}
            </button>
            {loading && <button onClick={stop} style={btnRed}>⏹ Стоп</button>}
            <button onClick={() => { setInput(''); setTask(null); setTaskId(null); }} disabled={loading} style={btnGhost}>Очистить</button>
          </div>

          {/* История задач */}
          {tasks.length > 0 && (
            <div style={{ marginTop: 20 }}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>История проверок</div>
              <div style={{ display: 'grid', gap: 6 }}>
                {tasks.map(t => (
                  <div key={t.id} onClick={() => openTask(t.id)} style={{ padding: '8px 12px', border: '1px solid #e8e8e6', borderRadius: 8, cursor: 'pointer', fontSize: 12, display: 'flex', gap: 12, alignItems: 'center', background: taskId === t.id ? '#f0effe' : '#fff' }}>
                    <span style={{ color: t.status === 'done' ? '#27ae60' : t.status === 'running' ? '#534AB7' : '#e67e22' }}>
                      {t.status === 'done' ? '✅' : t.status === 'running' ? '⏳' : '⏹'}
                    </span>
                    <span style={{ flex: 1 }}>#{t.id} · {t.checked}/{t.total}</span>
                    <span style={{ color: '#27ae60' }}>✅ {t.valid_count}</span>
                    <span style={{ color: '#c0392b' }}>👻 {t.not_found_count}</span>
                    <span style={{ color: '#aaa' }}>{t.created_at ? new Date(t.created_at).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : ''}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Правая колонка */}
        <div>
          {task ? (
            <>
              {/* Прогресс */}
              <div style={{ marginBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
                  <span style={{ fontWeight: 500 }}>
                    {task.status === 'done' ? '✅ Готово' : task.status === 'stopped' ? '⏹ Остановлено' : `⏳ ${task.checked} / ${task.total}`}
                  </span>
                  <span style={{ color: '#534AB7', fontWeight: 600 }}>{pct}%</span>
                </div>
                <div style={{ height: 8, background: '#f0f0ee', borderRadius: 4, overflow: 'hidden' }}>
                  <div style={{ height: '100%', background: task.status === 'done' ? '#27ae60' : '#534AB7', borderRadius: 4, width: `${pct}%`, transition: 'width 0.3s' }} />
                </div>
              </div>

              {/* Статистика */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 16 }}>
                <div style={{ background: '#eafaf0', borderRadius: 8, padding: '10px', textAlign: 'center' }}>
                  <div style={{ fontSize: 22, fontWeight: 700, color: '#27ae60' }}>{task.valid_count}</div>
                  <div style={{ fontSize: 11, color: '#27ae60' }}>✅ Валидных</div>
                </div>
                <div style={{ background: '#fdecea', borderRadius: 8, padding: '10px', textAlign: 'center' }}>
                  <div style={{ fontSize: 22, fontWeight: 700, color: '#c0392b' }}>{task.not_found_count}</div>
                  <div style={{ fontSize: 11, color: '#c0392b' }}>👻 Не найдено</div>
                </div>
                <div style={{ background: '#fef9f0', borderRadius: 8, padding: '10px', textAlign: 'center' }}>
                  <div style={{ fontSize: 22, fontWeight: 700, color: '#e67e22' }}>{task.already_count}</div>
                  <div style={{ fontSize: 11, color: '#e67e22' }}>🔄 Уже писали</div>
                </div>
              </div>

              {/* Логи */}
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Лог проверки</div>
              <div ref={logsRef} style={{ background: '#1a1a2e', borderRadius: 8, padding: 12, height: 220, overflow: 'auto', fontFamily: 'monospace', fontSize: 11, marginBottom: 12 }}>
                {task.logs.map((l, i) => (
                  <div key={i} style={{ color: l.startsWith('✅') ? '#4ade80' : l.startsWith('🔄') ? '#fbbf24' : l.startsWith('🔒') ? '#a78bfa' : l.startsWith('⏱') ? '#fb923c' : '#f87171', marginBottom: 2, lineHeight: 1.5 }}>
                    {l}
                  </div>
                ))}
                {task.status === 'running' && <div style={{ color: '#666' }}>▋</div>}
              </div>

              {/* Результат */}
              {(task.status === 'done' || task.status === 'stopped') && task.valid_phones.length > 0 && (
                <>
                  <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>Валидные номера</label>
                  <textarea value={task.valid_phones.join('\n')} readOnly rows={6}
                    style={{ ...inp, fontFamily: 'monospace', fontSize: 12, background: '#f9f9f9', resize: 'vertical' }} />
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={() => {
                      const el = document.createElement('textarea');
                      el.value = task.valid_phones.join('\n');
                      document.body.appendChild(el);
                      el.select();
                      document.execCommand('copy');
                      document.body.removeChild(el);
                      alert('Скопировано ' + task.valid_phones.length + ' номеров');
                    }} style={btnPrimary}>📋 Копировать валидные</button>
                    <button onClick={() => setInput(task.valid_phones.join('\n'))} style={btnGhost}>← В поле ввода</button>
                  </div>
                </>
              )}
            </>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#ccc', fontSize: 14, flexDirection: 'column', gap: 12 }}>
              <div style={{ fontSize: 48 }}>🔍</div>
              <div>Запустите проверку или выберите задачу из истории</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
